import { useSiteContext, useTranslation } from '@eti/providers';
import { CAN_NOT_SELECT_TRIP } from '../../constants/dataLayerEventsConstants';
import ErrorDialog from './ErrorDialog';

interface TripNotAvailableErrorModalProps {
  isOpen: boolean;
  onPrimaryAction: () => void;
}

const TripNotAvailableErrorModal = ({
  onPrimaryAction,
  isOpen,
}: TripNotAvailableErrorModalProps) => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();

  return (
    <ErrorDialog
      content={t('IbeClient.Error.TripNotAvailable.Content')}
      data-testid="noTrip-error-dialog"
      dataLayerEvent={CAN_NOT_SELECT_TRIP}
      isOpen={isOpen}
      onPrimaryAction={!agencyAccount ? onPrimaryAction : undefined}
      primaryButtonLabel={
        !agencyAccount ? t('IbeClient.Error.TripNotAvailable.Btn.Text') : undefined
      }
      title={t('IbeClient.Error.TripNotAvailable.Header')}
    />
  );
};

export default TripNotAvailableErrorModal;
